import styled from 'styled-components'

export const GalleryContainer = styled.div`
  .image-gallery-thumbnails-container {
    padding-top: 1rem;
    display: flex !important;
    justify-content: center;
    gap: 0.6rem !important;
    flex-wrap: wrap;
  }

  .image-gallery-thumbnail {
    border-radius: 0.5rem;
    overflow: hidden;
    border: 2px solid #f1f5f9;
    transition: all 0.2s ease;
    width: 80px !important;
    height: 80px !important;
  }

  .image-gallery-thumbnail.active,
  .image-gallery-thumbnail:hover {
    opacity: 1;
    border-width: 1px;
    border-color: #ff9999;
    transform: translateY(-2px);
  }
`

const shadowMd =
  '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
const shadowLg =
  '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
const ringColor = '#FF4061'
const ringOffsetColor = '#FFFFFF'

export const ColorOption = styled.div.attrs(props => ({
  style: {
    backgroundColor: props.color,
  },
}))`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  box-shadow: ${props =>
    props.isActive
      ? `${shadowLg}, 0 0 0 2px ${ringOffsetColor}, 0 0 0 3px ${ringColor}`
      : shadowMd};

  &:hover {
    transform: scale(1.1);
    box-shadow: ${props =>
      props.isActive
        ? `${shadowLg}, 0 0 0 2px ${ringOffsetColor}, 0 0 0 3px ${ringColor}`
        : shadowLg};
  }

  &:active {
    transform: scale(0.95);
  }

  ${({ isActive }) =>
    isActive &&
    `
      box-shadow: ${shadowLg}, 0 0 0 2px ${ringOffsetColor}, 0 0 0 3px ${ringColor};
    `}
`
